module.exports = __webpack_public_path__ + "img/bt.95e60880.png";